import React from 'react'
import { RiskProductTabs } from './RiskProductTabs'

export const Index = () => {
  return (
    <>
      <RiskProductTabs />
    </>
  )
}
